import React, { memo, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import AutoSizer from "react-virtualized-auto-sizer";
import { isMobile } from "react-device-detect";

import IndustryPriceRatioChangeChart from "./IndustryPriceRatioChangeChart";
import IDXNumberStockChart from "../index-components/IDXNumberStockChart";
import IDXValueScaleChart from "../index-components/IDXValueScaleChart";
import IndustryForeignQttyScale from "./IndustryForeignQttyScale";

import { priceToNumber, signNumber, formatNumber, formatNumber_N1, formatNumberToB_N1, formatNumberToM, formatQtty } from "../../helpers/utils";
import clsx from "clsx";
import { HighlightSpan } from "../PriceBoardTotalMode";

export default memo(
   function IndustryIndexDetailViewTable(props) {
      // const { industryCode } = props;
      const { t } = useTranslation();
      const popupConfig = useSelector((state) => state.gShared.popupConfig);
      const symbolInfo = useSelector((state) => state.gSymbol.symbolInfos.find((item) => item.code === popupConfig.code)) ?? {};
      const groupSymbol = useSelector((state) =>
         state.gShared.industries.find((e) => (popupConfig.type === "ST" && e.symbolList.indexOf(popupConfig.code) >= 0) || (popupConfig.type === "IND" && e.code === popupConfig.code))
      );
      const prevSymbolCode = useRef(""); // .current
      const industryCode = groupSymbol?.code;
      const i_counter = useSelector((state) => state.gIndex.indexInfos.find((e) => e.indexCode === industryCode)?.counter);
      const industryIndex = useSelector((state) => state.gIndex.indexInfos.find((e) => e.indexCode === industryCode));
      const _priceRatioChange = priceToNumber(industryIndex?.priceRatioChange);
      const _colorClass = _priceRatioChange > 0 ? "clr-up" : _priceRatioChange < 0 ? "clr-down" : "clr-ref";
      const priceBoardIsOddlot = useSelector((state) => state.gShared.priceBoardIsOddlot);
      const tabIsFocus = useSelector((state) => state.gShared.tabIsFocus);
      const _fireEvent = prevSymbolCode.current === symbolInfo.code && tabIsFocus;
      //

      useEffect(() => {
         prevSymbolCode.current = symbolInfo.code;
      }, [symbolInfo.code]);

      return (
         <>
            <table className="tb-popup-detail mr-bottom_15">
               <thead className="text-center">
                  <tr>
                     <th rowSpan="2" width="5%">
                        {t("giaHienTai")}
                     </th>
                     <th rowSpan="2"> {t("thaydoiDetailStock")}</th>
                     <th rowSpan="2">%</th>
                     <th rowSpan="2">{t("maxDetailStock")}</th>
                     <th rowSpan="2">{t("minDetailStock")}</th>
                     <th rowSpan="2" width="10%">
                        {t("KLGDDetailStock")}
                     </th>
                     <th rowSpan="2" width="10%">
                        {t("GTGDDetailStock")}
                     </th>
                     <th colSpan="6" className="text-center">
                        {t("mua")}
                     </th>
                     <th colSpan="6" className="text-center">
                        {t("ban")}
                     </th>
                  </tr>
                  <tr>
                     <th>{t("gia3")}</th>
                     <th>{t("kl3")}</th>
                     <th>{t("gia2")}</th>
                     <th>{t("kl2")}</th>
                     <th>{t("gia1")}</th>
                     <th>{t("kl1")}</th>

                     <th>{t("gia1")}</th>
                     <th>{t("kl1")}</th>
                     <th>{t("gia2")}</th>
                     <th>{t("kl2")}</th>
                     <th>{t("gia3")}</th>
                     <th>{t("kl3")}</th>
                  </tr>
               </thead>
               <tbody>
                  {/* <tr>
              <td className={"text-center"}>{groupSymbol ? t("codeIndustry_" + groupSymbol.code) : ""}</td>
              <td className={"text-center"}>{formatNumber_N1(industryIndex?.totalTradedQttyNM)}</td>
              <td className={"text-center"}>
                {formatNumberToB_N1(industryIndex?.totalTradedValue)}{" "}
                {industryIndex?.totalTradedValue && industryIndex?.totalTradedValue != 0 ? t("ty") : ""}
              </td>
              <td className={"text-center"}>{formatNumber_N1(industryIndex?.totalTradedQttyNM)}</td>
              <td className={"text-center"}>
                {formatNumberToB_N1(industryIndex?.totalTradedValueNM)}{" "}
                {industryIndex?.totalTradedValueNM && industryIndex?.totalTradedValueNM != 0 ? t("ty") : ""}
              </td>
              <td className={"text-center"}>{formatNumber_N1(industryIndex?.totalTradedQttyPT)}</td>
              <td className={"text-center"}>
                {formatNumberToB_N1(industryIndex?.totalTradedValuePT)}{" "}
                {industryIndex?.totalTradedValuePT && industryIndex?.totalTradedValuePT != 0 ? t("ty") : ""}
              </td>
              <td className={"text-center"}>{formatNumber_N1(industryIndex?.buyForeignQtty)}</td>
              <td className={"text-center"}>{formatNumber_N1(industryIndex?.sellForeignQtty)}</td>
              <td className={"text-center"}>{formatNumber_N1(industryIndex?.subForeignQtty)}</td>
            </tr> */}
                  {priceBoardIsOddlot ? (
                     <tr>
                        <td className={clsx("text-center", symbolInfo.matchPriceOdd_color)}>
                           <HighlightSpan id={symbolInfo.code + "_matchPriceOdd_dt"} value={symbolInfo.matchPriceOdd} fireEvent={_fireEvent} />
                        </td>

                        <td className={clsx("text-center", symbolInfo.matchPriceOdd_color)}>
                           <HighlightSpan id={symbolInfo.code + "_changePriceOdd_dt"} value={symbolInfo.changePriceOdd} fireEvent={_fireEvent} />
                        </td>

                        <td className={clsx("text-center", symbolInfo.matchPriceOdd_color)}>
                           <HighlightSpan
                              id={symbolInfo.code + "_pctChangePriceOdd_dt"}
                              value={symbolInfo.pctChangePriceOdd + (symbolInfo.pctChangePriceOdd && symbolInfo.pctChangePriceOdd !== "" ? "%" : "")}
                              fireEvent={_fireEvent}
                           />
                        </td>

                        <td className={clsx("text-center", symbolInfo.highestPrice_color)}></td>
                        <td className={clsx("text-center", symbolInfo.lowestPrice_color)}></td>
                        <td className={clsx("text-center bg-smoke")}>
                           <HighlightSpan id={symbolInfo.code + "_totalTradedQttyOdd_dt"} value={formatNumber(symbolInfo.totalTradedQttyOdd)} fireEvent={_fireEvent} />
                        </td>
                        <td className={clsx("text-center bg-smoke")}>
                           <HighlightSpan id={symbolInfo.code + "_totalTradedValueOdd_dt"} value={formatNumberToM(symbolInfo.totalTradedValueOdd)} fireEvent={_fireEvent} />
                        </td>

                        {/* HERE */}

                        <td className={clsx("text-center", symbolInfo.bidPriceOdd3_color)}>
                           <HighlightSpan id={symbolInfo.code + "_bidPriceOdd3_dt"} value={symbolInfo.bidPriceOdd3} fireEvent={_fireEvent} />
                        </td>
                        <td className={clsx("text-center", symbolInfo.bidPriceOdd3_color)}>
                           <HighlightSpan id={symbolInfo.code + "_bidQttyOdd3_dt"} value={formatNumber(symbolInfo.bidQttyOdd3)} fireEvent={_fireEvent} />
                        </td>
                        <td className={clsx("text-center", symbolInfo.bidPriceOdd2_color)}>
                           <HighlightSpan id={symbolInfo.code + "_bidPriceOdd2_dt"} value={symbolInfo.bidPriceOdd2} fireEvent={_fireEvent} />
                        </td>
                        <td className={clsx("text-center", symbolInfo.bidPriceOdd2_color)}>
                           <HighlightSpan id={symbolInfo.code + "_bidQttyOdd2_dt"} value={formatNumber(symbolInfo.bidQttyOdd2)} fireEvent={_fireEvent} />
                        </td>
                        <td className={clsx("text-center", symbolInfo.bidPriceOdd1_color)}>
                           <HighlightSpan id={symbolInfo.code + "_bidPriceOdd1_dt"} value={symbolInfo.bidPriceOdd1} fireEvent={_fireEvent} />
                        </td>
                        <td className={clsx("text-center", symbolInfo.bidPriceOdd1_color)}>
                           <HighlightSpan id={symbolInfo.code + "_bidQttyOdd1_dt"} value={formatNumber(symbolInfo.bidQttyOdd1)} fireEvent={_fireEvent} />
                        </td>

                        {/* Ban */}
                        <td className={clsx("text-center", symbolInfo.offerPriceOdd1_color)}>
                           <HighlightSpan id={symbolInfo.code + "_offerPriceOdd1_dt"} value={symbolInfo.offerPriceOdd1} fireEvent={_fireEvent} />
                        </td>
                        <td className={clsx("text-center", symbolInfo.offerPriceOdd1_color)}>
                           <HighlightSpan id={symbolInfo.code + "_offerQttyOdd1_dt"} value={formatNumber(symbolInfo.offerQttyOdd1)} fireEvent={_fireEvent} />
                        </td>
                        <td className={clsx("text-center", symbolInfo.offerPriceOdd2_color)}>
                           <HighlightSpan id={symbolInfo.code + "_offerPriceOdd2_dt"} value={symbolInfo.offerPriceOdd2} fireEvent={_fireEvent} />
                        </td>
                        <td className={clsx("text-center", symbolInfo.offerPriceOdd2_color)}>
                           <HighlightSpan id={symbolInfo.code + "_offerQttyOdd2_dt"} value={formatNumber(symbolInfo.offerQttyOdd2)} fireEvent={_fireEvent} />
                        </td>
                        <td className={clsx("text-center", symbolInfo.offerPriceOdd3_color)}>
                           <HighlightSpan id={symbolInfo.code + "_offerPriceOdd3_dt"} value={symbolInfo.offerPriceOdd3} fireEvent={_fireEvent} />
                        </td>
                        <td className={clsx("text-center", symbolInfo.offerPriceOdd3_color)}>
                           <HighlightSpan id={symbolInfo.code + "_offerQttyOdd3_dt"} value={formatNumber(symbolInfo.offerQttyOdd3)} fireEvent={_fireEvent} />
                        </td>
                     </tr>
                  ) : (
                     <tr>
                        <td className={clsx("text-center", symbolInfo.matchPrice_color)}>
                           <HighlightSpan id={symbolInfo.code + "_matchPrice_dt"} value={symbolInfo.matchPrice} fireEvent={_fireEvent} />
                        </td>
                        <td className={clsx("text-center", symbolInfo.matchPrice_color)}>
                           <HighlightSpan id={symbolInfo.code + "_changePrice_dt"} value={symbolInfo.changePrice} fireEvent={_fireEvent} />
                        </td>
                        <td className={clsx("text-center", symbolInfo.matchPrice_color)}>
                           <HighlightSpan
                              id={symbolInfo.code + "_pctChangePrice_dt"}
                              value={symbolInfo.pctChangePrice + (symbolInfo.pctChangePrice && symbolInfo.pctChangePrice !== "" ? "%" : "")}
                              fireEvent={_fireEvent}
                           />
                        </td>

                        <td className={clsx("text-center", symbolInfo.highestPrice_color)}>
                           <HighlightSpan id={symbolInfo.code + "_highestPrice_dt"} value={symbolInfo.highestPrice} fireEvent={_fireEvent} />
                        </td>
                        <td className={clsx("text-center", symbolInfo.lowestPrice_color)}>
                           <HighlightSpan id={symbolInfo.code + "_lowestPrice_dt"} value={symbolInfo.lowestPrice} fireEvent={_fireEvent} />
                        </td>
                        <td className={clsx("text-center")}>
                           <HighlightSpan id={symbolInfo.code + "_totalTradedQttyNM_dt"} value={formatQtty(symbolInfo.totalTradedQttyNM)} fireEvent={_fireEvent} />
                        </td>

                        <td className={clsx("text-center")}>
                           <HighlightSpan id={symbolInfo.code + "_totalTradedValueNM_dt"} value={formatNumberToM(symbolInfo.totalTradedValueNM)} fireEvent={_fireEvent} />
                        </td>

                        {/* Mua */}
                        <td className={clsx("text-center", symbolInfo.bidPrice3_color)}>
                           <HighlightSpan id={symbolInfo.code + "_bidPrice3_dt"} value={symbolInfo.bidPrice3} fireEvent={_fireEvent} />
                        </td>
                        <td className={clsx("text-center", symbolInfo.bidPrice3_color)}>
                           <HighlightSpan id={symbolInfo.code + "_bidQtty3_dt"} value={formatQtty(symbolInfo.bidQtty3)} fireEvent={_fireEvent} />
                        </td>
                        <td className={clsx("text-center", symbolInfo.bidPrice2_color)}>
                           <HighlightSpan id={symbolInfo.code + "_bidPrice2_dt"} value={symbolInfo.bidPrice2} fireEvent={_fireEvent} />
                        </td>
                        <td className={clsx("text-center", symbolInfo.bidPrice2_color)}>
                           <HighlightSpan id={symbolInfo.code + "_bidQtty2_dt"} value={formatQtty(symbolInfo.bidQtty2)} fireEvent={_fireEvent} />
                        </td>
                        <td className={clsx("text-center", symbolInfo.bidPrice1_color)}>
                           <HighlightSpan id={symbolInfo.code + "_bidPrice1_dt"} value={symbolInfo.bidPrice1} fireEvent={_fireEvent} />
                        </td>
                        <td className={clsx("text-center", symbolInfo.bidPrice1_color)}>
                           <HighlightSpan id={symbolInfo.code + "_bidQtty1_dt"} value={formatQtty(symbolInfo.bidQtty1)} fireEvent={_fireEvent} />
                        </td>

                        {/* BAN */}
                        <td className={clsx("text-center", symbolInfo.offerPrice1_color)}>
                           <HighlightSpan id={symbolInfo.code + "_offerPrice1_dt"} value={symbolInfo.offerPrice1} fireEvent={_fireEvent} />
                        </td>
                        <td className={clsx("text-center", symbolInfo.offerPrice1_color)}>
                           <HighlightSpan id={symbolInfo.code + "_offerQtty1_dt"} value={formatQtty(symbolInfo.offerQtty1)} fireEvent={_fireEvent} />
                        </td>
                        <td className={clsx("text-center", symbolInfo.offerPrice2_color)}>
                           <HighlightSpan id={symbolInfo.code + "_offerPrice2_dt"} value={symbolInfo.offerPrice2} fireEvent={_fireEvent} />
                        </td>
                        <td className={clsx("text-center", symbolInfo.offerPrice2_color)}>
                           <HighlightSpan id={symbolInfo.code + "_offerQtty2_dt"} value={formatQtty(symbolInfo.offerQtty2)} fireEvent={_fireEvent} />
                        </td>
                        <td className={clsx("text-center", symbolInfo.offerPrice3_color)}>
                           <HighlightSpan id={symbolInfo.code + "_offerPrice3_dt"} value={symbolInfo.offerPrice3} fireEvent={_fireEvent} />
                        </td>
                        <td className={clsx("text-center", symbolInfo.offerPrice3_color)}>
                           <HighlightSpan id={symbolInfo.code + "_offerQtty3_dt"} value={formatQtty(symbolInfo.offerQtty3)} fireEvent={_fireEvent} />
                        </td>
                     </tr>
                  )}
               </tbody>
            </table>
         </>
      );
   },
   (prevProps, nextProps) => {
      if (prevProps.industryCode === nextProps.industryCode) {
         return true;
      }
      return false;
   }
);
